import React, { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import styled from 'react-emotion'
import { language } from '../../../resources'
import getText from '../../strings'
import { ModalOverlay, ModalDialog } from '../../../styles'
import * as Mutations from '../../mutations'

const Container = styled('div')`
  display: flex;
`

const Name = styled('span')`
  margin-right: 12px;
`

const ConnectionWrapper = styled('div')``

const MembershipId = styled('span')`
  font-weight: bold;
  margin-right: 12px;
`

const ActionButton = styled('a')``

const Buttons = styled('div')`
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  button:first-child {
    width: 100%;
    margin-right: 10px;
  }
  button:last-child {
    width: 100%;
    margin-left: 10px;
  }
`

const Button = styled('button')`
  white-space: nowrap;
`

const Inputs = styled('div')`
  padding: 5px 0;
`

const Label = styled('label')``

const Input = styled('input')`
  width: 100%;
`

const Error = styled('div')`
  margin-top: 12px;
`

export default ({ data, onSave }) => {
  const [connecting, setConnecting] = useState(false)
  const [disconnecting, setDisconnecting] = useState(false)
  const [error, setError] = useState(false)
  const [showConnectModal, setShowConnectModal] = useState(false)
  const [showDisconnectModal, setShowDisconnectModal] = useState(false)

  const [memberId, setMemberId] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')

  const connectPartner = useMutation(Mutations.connectScandicPartner)
  const removePartner = useMutation(Mutations.removePartner)

  const connect = () => {
    setConnecting(true)
    connectPartner({
      variables: {
        memberId,
        firstName,
        lastName,
      },
      update: (_, mutationResult) => {
        if (mutationResult.data.connectScandicPartner.success) {
          setConnecting(false)
          setError(false)
          setShowConnectModal(false)
          onSave()
        } else {
          setError(mutationResult.data.connectScandicPartner.errorCode)
          setConnecting(false)
        }
      },
    })
  }

  const disconnect = () => {
    setDisconnecting(true)
    removePartner({
      variables: {
        partnerId: 'SCANDIC',
      },
      update: (_, mutationResult) => {
        if (mutationResult.data.removePartner) {
          setDisconnecting(false)
          setError('GENERAL_ERROR')
          setShowDisconnectModal(false)
          onSave()
        } else {
          setError(true)
          setDisconnecting(false)
        }
      },
    })
  }

  const handleConnect = () => {
    setShowConnectModal(true)
  }

  const handleDisconnect = () => {
    setShowDisconnectModal(true)
  }

  const handleMemberIdChange = (e) => {
    setMemberId(e.target.value)
  }

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value)
  }

  const handleLastNameChange = (e) => {
    setLastName(e.target.value)
  }

  if (!data) {
    return null
  }

  return (
    <Container>
      <Name>{getText('partners', 'scandic', 'title')}: </Name>
      {data.memberId && (
        <ConnectionWrapper>
          <MembershipId>{data.memberId}</MembershipId>
          <ActionButton onClick={handleDisconnect} href="javascript:void()">
            {getText('partners', 'scandic', 'disconnect')}
          </ActionButton>
        </ConnectionWrapper>
      )}
      {!data.memberId && (
        <ConnectionWrapper>
          <ActionButton onClick={handleConnect} href="javascript:void()">
            {getText('partners', 'scandic', 'connect')}
          </ActionButton>
        </ConnectionWrapper>
      )}

      {showConnectModal && (
        <ModalOverlay>
          <ModalDialog width={400}>
            <h3>{getText('partners', 'scandic', 'titleConnect')}</h3>
            <Inputs>
              <Label>{getText('partners', 'scandic', 'memberId')}:</Label>
              <Input type="text" onChange={handleMemberIdChange} />
            </Inputs>
            <Inputs>
              <Label>{getText('partners', 'scandic', 'firstName')}:</Label>
              <Input type="text" onChange={handleFirstNameChange} />
            </Inputs>
            <Inputs>
              <Label>{getText('partners', 'scandic', 'lastName')}:</Label>
              <Input type="text" onChange={handleLastNameChange} />
            </Inputs>
            {error && <Error>{getText('partners', 'scandic', error)}</Error>}
            <Buttons>
              <Button onClick={() => connect()} className="btn btn-function" disabled={connecting}>
                {getText('partners', 'scandic', 'connect')}
              </Button>
              <Button onClick={() => setShowConnectModal(false) && setError(false)} className="btn ghost-blue" disabled={connecting}>
                {getText('partners', 'scandic', 'cancel')}
              </Button>
            </Buttons>
          </ModalDialog>
        </ModalOverlay>
      )}

      {showDisconnectModal && (
        <ModalOverlay>
          <ModalDialog width={400}>
            <h3>{getText('partners', 'scandic', 'titleDisconnect')}</h3>
            {error && <Error>{getText('partners', 'scandic', error)}</Error>}
            <Buttons>
              <Button onClick={() => disconnect()} className="btn btn-function" disabled={disconnecting}>
                {getText('partners', 'scandic', 'disconnect')}
              </Button>
              <Button onClick={() => setShowDisconnectModal(false) && setError(false)} className="btn ghost-blue" disabled={disconnecting}>
                {getText('partners', 'scandic', 'cancel')}
              </Button>
            </Buttons>
          </ModalDialog>
        </ModalOverlay>
      )}
    </Container>
  )
}
